import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../store';

export interface InterfaceState {
  sidebar_toggled: boolean;
  alert: { open: boolean; text: string; type: 'success' | 'error' };
}

const initialState: InterfaceState = {
  sidebar_toggled: false,
  alert: { open: false, text: '', type: 'success' },
};

export const interfaceSlice = createSlice({
  name: 'interface',
  initialState,
  reducers: {
    setSidebarToggled: (state, action: PayloadAction<boolean>) => {
      state.sidebar_toggled = action.payload;
    },
    setAlertToggled: (state, action: PayloadAction<boolean>) => {
      state.alert.open = action.payload;
    },
    setAlertText: (state, action: PayloadAction<string>) => {
      state.alert.text = action.payload;
    },
    setAlertType: (state, action: PayloadAction<'success' | 'error'>) => {
      state.alert.type = action.payload;
    },
  },
});

export const { setSidebarToggled, setAlertToggled, setAlertText, setAlertType } =
  interfaceSlice.actions;

export const selectSidebarToggled = (state: RootState): boolean =>
  state.interface.sidebar_toggled;
export const selectAlertOpen = (state: RootState): boolean => state.interface.alert.open;
export const selectAlertText = (state: RootState): string => state.interface.alert.text;
export const selectAlertType = (state: RootState): typeof state.interface.alert.type =>
  state.interface.alert.type;

export default interfaceSlice.reducer;
